// extracted by mini-css-extract-plugin
module.exports = {"ui_different_row":"TableDifferentRow_ui_different_row__FE6Iu","ui_different_row_inverse":"TableDifferentRow_ui_different_row_inverse__GvOU3"};